import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../../../../shared/modules/configurable-form/models/on-field-changed';
import { UntypedFormGroup } from '@angular/forms';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';
import { ConfigurableFormComponent } from '../../../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';

export enum PipeQuantityCodes {
  StationaryPipe = '60001675',
}

@Injectable()
export class HandlePipeQuantityCommand implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    const hide = value !== PipeQuantityCodes.StationaryPipe;
    if (hide) {
      form.setValue(SpecFieldNames.PIPE_QUANTITY, 10);
    }

    form.setDisabled(SpecFieldNames.PIPE_QUANTITY, hide);
    form.setHidden(SpecFieldNames.PIPE_QUANTITY, hide);
  }
}
